<template>
  <div class="home">
    <div class="jumbotron">
      <h1 class="display-3">慎独谏</h1>
      <p
        class="lead"
      >
      千辛万苦修此身，<br>
      何来此间意消沉？<br>
      万紫千红虽艳丽，<br>
      不若空念保自真。<br>
      </p>
      <hr class="my-4" />
      <p class="lead">
        <a class="btn btn-primary btn-lg" href="http://web.nutbrain.cn" role="button">离开</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  props: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  display: block;
  color: #42b983;
  max-width: 200px;
  margin: 0 auto;
}
h1{
  text-align: center;
}
p{
  text-align: center;
}
</style>
